module.exports = __webpack_public_path__ + "static/img/videoDefault.3b22e45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videoDefault.jpg
// module id = 743
// module chunks = 0 1 3